import * as SDK from '@siloreal:shared:sdk';
const { ok, err } = SDK.core;
type ValidationFn = SDK.validator.form.ValidationFn;

import * as v from 'valibot';

const DEFAULT_MESSAGES = {
  type: 'La contraseña debe ser texto',
  required: 'La contraseña es requerida',
  length: {
    min: 'La contraseña debe tener al menos 8 caracteres',
    max: 'La contraseña debe tener como máximo 256 caracteres, ¿qué hacés? ✋',
  },
  lowercase: 'La contraseña debe contener al menos una letra minúscula',
  uppercase: 'La contraseña debe contener al menos una letra mayúscula',
  number: 'La contraseña debe contener al menos un número',
  special: 'La contraseña debe contener al menos un carácter especial',
  unknown: 'Error desconocido.',
};

const PasswordSchema = v.pipe(
  v.string(DEFAULT_MESSAGES.type),
  v.nonEmpty(DEFAULT_MESSAGES.required),
  v.minLength(8, DEFAULT_MESSAGES.length.min),
  v.maxLength(256, DEFAULT_MESSAGES.length.max),
  v.regex(/[a-z]/, DEFAULT_MESSAGES.lowercase),
  v.regex(/[A-Z]/, DEFAULT_MESSAGES.uppercase),
  v.regex(/[0-9]/, DEFAULT_MESSAGES.number),
  v.regex(/[^a-zA-Z0-9]/, DEFAULT_MESSAGES.special)
);

const schema = {
  required: PasswordSchema,
  optional: v.union([v.literal(''), PasswordSchema]),
};

export const password: ValidationFn = (value, options = {}) => {
  const { required = false } = options;

  const effectiveSchema = required ? schema.required : schema.optional;
  const result = v.safeParse(effectiveSchema, value);

  return result.success //
    ? ok(result.output)
    : err(result.issues[0]?.message ?? DEFAULT_MESSAGES.unknown);
};
